/**
 * Sleek Theme - Footer Component JS
 * Handles Country/Markets disclosure popup, mobile accordions, and newsletter interaction
 */

class FooterLocalizationDisclosure extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('[data-disclosure-toggle]');
    this.panel = this.querySelector('[data-disclosure-panel]');
    this.form = this.querySelector('form');
    this.options = this.querySelectorAll('.country-disclosure__option');

    if (!this.toggle || !this.panel) return;

    this.toggle.addEventListener('click', this.togglePanel.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));
    document.addEventListener('keyup', this.onKeyUp.bind(this));

    this.options.forEach((option) => {
      option.addEventListener('click', (e) => {
        // Allow form submission to handle Shopify localization routing
        this.closePanel();
      });
    });
  }

  togglePanel(e) {
    e.stopPropagation();
    const isExpanded = this.toggle.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      this.closePanel();
    } else {
      this.openPanel();
    }
  }

  openPanel() {
    this.panel.classList.remove('hidden');
    this.toggle.setAttribute('aria-expanded', 'true');
    const firstOption = this.panel.querySelector('button');
    if (firstOption) firstOption.focus();
  }

  closePanel() {
    this.panel.classList.add('hidden');
    this.toggle.setAttribute('aria-expanded', 'false');
  }

  onDocumentClick(e) {
    if (!this.contains(e.target)) {
      this.closePanel();
    }
  }

  onKeyUp(e) {
    if (e.key === 'Escape') {
      this.closePanel();
      this.toggle.focus();
    }
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', FooterLocalizationDisclosure);
}

// Mobile Accordion Auto-close behavior on resize
window.addEventListener('resize', () => {
  const details = document.querySelectorAll('.footer-accordion');
  if (window.innerWidth >= 990) {
    details.forEach(detail => detail.setAttribute('open', ''));
  }
});
